/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 */

export const register = (property: any) => {
  if (property) {
    if (window.dataLayer) {
      window.dataLayer.push({
        // @ts-expect-error
        event: 'mixpanelRegister',
        mixpanelPayload: property,
      })
    } else {
      window.mixpanel?.register?.(property)
    }
  }
}
